import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineTuitionFee extends TitleBase {
	private disciplineValue: string;
	private tuitionFeeValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.tuitionFeeValue = this.getFilterValue(ParameterType.TUITION_FEE);
		const countryContinentFilter = this.filters.filter(
			(_) => _.values.length > 1 && (_.type === ParameterType.COUNTRY || _.type === ParameterType.CONTINENT),
		);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE) &&
			countryContinentFilter.length === 0
		);
	}

	protected getPageTitle(): string {
		return `${this.tuitionFeeValue} ${this.titlePortalType} in ${this.disciplineValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.tuitionFeeValue.toLowerCase()} ${this.titlePortalType} in the field of ${this.disciplineValue}`,
			' worldwide',
		);
	}
}
